/*
 * @Description:
 * @Autor: wanglu
 * @Date: 2021-12-28 15:21:31
 * @LastEditors: wanglu
 * @LastEditTime: 2022-05-26 09:43:49
 * @FilePath: /ljsite-vue/src/main-nportal.js
 */
import "core-js/stable";
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router/nportal";
import { VueAxios } from "./utils/request";
import "./core/nportal_use"; //组建配置
import "./core/antdv_use"; //组建配置

// import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "./assets/table.less"; // table样式
import "./assets/nportal.less"; // table样式
import "babel-polyfill";
// 使用element-ui框架
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
// Vue.use(Antd);
Vue.config.productionTip = false;
Vue.use(VueAxios);

new Vue({
  router,
  store,
  created: () => {
    if (
      typeof window !== "undefined" &&
      typeof window.navigator !== "undefined"
    ) {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        window.location.href = "http://www.longjitech.com/mobile/";
      } else {
      }
    }
    Vue.ls.get("ACCESS_TOKEN") &&
      store.commit("SET_TOKEN", Vue.ls.get("ACCESS_TOKEN"));
  },
  render: (h) => h(App),
}).$mount("#app");
